<template>
  <el-main class="dynamic">
    <ContentNav
      :bannerTextIMG="require('../../assets/dynamic/bannerText.png')"
      :bannerimgIMG="Url.imgUrl + this.$store.state.NavList[3].banner"
    ></ContentNav>
    <div class="content">
      <div class="case-details">
        <div class="title">{{ articleDeatl.title }}</div>
        <el-divider></el-divider>
        <div class="infor">
          <div class="time">
            <i class="el-icon-time"></i>
            <span>{{ articleDeatl.publishTime }}</span>
          </div>
          <div class="minus">
            <i class="el-icon-view"></i>
            <span>{{ articleDeatl.hits }}</span>
          </div>
          <!-- <div class="label">
						<i class="el-icon-price-tag"></i>
						<span>{{ articleDeatl.keyWord }}</span>
					</div> -->
        </div>
        
        <div class="text" v-html="articleDeatl.contents"></div>
        <div class="last_next">
          <div class="item" @click="toDetails(prve.id)">
            <i class="el-icon-back"></i>
            <span>上一篇：{{ prve.title }}</span>
          </div>
          <div class="item" @click="toDetails(next.id)">
            <span>下一篇：{{ next.title }}</span>
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
    </div>
    <Icongroup></Icongroup>
  </el-main>
</template>

<script>
import ContentNav from "../../components/ContentNav";
import Icongroup from "../../components/Icon_group";

export default {
  props: ["id"],
  components: {
    ContentNav,
    Icongroup,
  },
  metaInfo() {
    return {
      title: `${(this.articleDeatl.title ?? "") + "-"}${this.SystemOption
        .seoTitle ?? ""}`,
      meta: [
        {
          // set meta
          name: "keywords",
          content: this.articleDeatl.keyWord ?? "",
        },
        {
          // set meta
          name: "description",
          content: this.articleDeatl.describe ?? "",
        },
      ],
    };
  },
  data() {
    return {
      articleDeatl: Object, //文章详情
      SystemOption: [], //SEO 配置
      prve: {
        id: 0,
        title: "",
      },
      next: {
        id: 0,
        title: "",
      },
    };
  },
  methods: {
    getDetails() {
      let that = this;
      let id = that.id;
      that
        .axios({
          type: "get",
          url: this.Url.apiUrl + "Articles/Detail",
          params: {
            id: id,
          },
        })
        .then((res) => {
          that.articleDeatl = res.data;
        });
    },
    //加载上下篇
    getPrveNext() {
      this.getDetails();
      let that = this;
      let type = 1;
      let id = that.id;
      let order = this.$store.state.dynamicOrder;
      that
        .axios({
          type: "get",
          url: this.Url.apiUrl + "Articles/GetPreOrNext",
          params: {
            id: id,
            type: type,
            order: order,
          },
        })
        .then((res) => {
          console.log(res.data);
          that.prve.id = res.data.preID;
          that.prve.title = res.data.preTitle;
          that.next.id = res.data.nextID;
          that.next.title = res.data.nextTitle;
          // that.articleDeatl = res.data;
        });
    },
    toDetails(id) {
      if (id <= 0) {
        return false;
      }
      let that = this;
      that.id = id;
      this.$router.push({
        name: "article-details",
        params: {
          id: that.id,
        },
      });
      that.getDetails();
      that.getPrveNext();
    },
    loadSeo() {
      //获取SEO配置
      this.axios
        .get(this.Url.apiUrl + "SystemOption/GetSystemOption")
        .then((res) => (this.SystemOption = res.data));
    },
  },
  created() {
    let pos = {
      path: "/dynamic.html",
      name: "律所动态",
    };
    //初始化路径数据
    this.$store.state.Currentposition = [
      {
        path: "/",
        name: "首页",
      },
      pos,
    ];
    this.getDetails();
    this.getPrveNext();
    this.loadSeo();
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  width: 1200px;
  display: block;
  margin: 0 auto;
  padding: 40px 0 120px 0;

  @media screen and (max-width: 768px) {
    padding: 26px 21px;
    width: 100%;
  }

  .select {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .TimeOrder {
      flex: 0 0 150px;
      display: flex;
      color: #202020;
      align-items: center;

      @media screen and (max-width: 768px) {
        display: none;
      }

      i {
        flex: 0 0 8px;
        height: 17px;
        margin: 0 10px;
        font-size: 18px;
        cursor: pointer;
      }
    }

    .InputBox {
      @media screen and (max-width: 768px) {
        width: 100%;

        input {
          width: 100%;
        }
      }
    }
  }

  .itemList {
    position: relative;
    display: block;
    width: 100%;
    margin: 20px 0 0 0;

    .itemList-box {
      border-bottom: 1px solid #d8d8d8;
      height: 94px;
      margin: 5px 0;

      @media screen and (max-width: 768px) {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .title {
        color: #202020;
        font-weight: 600;
        line-height: 36px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        @media screen and (max-width: 768px) {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 13px;
        }
      }
      .text {
        font-size: 14px;
        color: #908c86;
        line-height: 18px;

        @media screen and (max-width: 768px) {
          font-size: 10px;
          text-overflow: ellipsis;
          font-size: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .box-bottom {
        .articles_content {
          flex: 0 0 70%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .Pages {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .case-details {
    position: relative;
    flex: 0 0 950px;

    .title {
      font-size: 16px;
      font-weight: 600;
      color: #4b4b4b;
      text-align: center;
    }

    .infor {
      font-size: 12px;
      color: #787878;
      display: flex;
      justify-content: center;

      @media screen and (max-width: 768px) {
        justify-content: space-around;
        align-items: center;
      }

      > div {
        margin-right: 66px;

        @media screen and (max-width: 768px) {
          margin-right: 0;
        }

        i {
          margin-right: 15px;

          @media screen and (max-width: 768px) {
            margin-right: 5px;
          }
        }
      }
    }

    .text {
      font-size: 13px;
      color: #787878;
      margin-top: 18px;
      line-height: 20px;
      max-width: 100%;

      div {
        text-align: center;

        img {
          margin: 20px auto;

          @media screen and (max-width: 768px) {
            width: 100%;
          }
        }
      }
    }

    .last_next {
      position: relative;
      display: flex;
      height: 80px;
      margin-top: 15px;
      .item {
        flex: 0 0 50%;
        background-color: rgba(240, 240, 240, 0.44);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #797979;
        cursor: pointer;
        user-select: none;
        transition: 200ms;
        span{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width:80%;
        }
        i {
          font-size: 20px;
          margin: 0 15px;
        }
      }

      .item:first-of-type {
        border-right: 1px solid rgba(240, 240, 240, 1);
      }

      .item:active {
        background-color: #d0a971;
        color: #fff;
      }
    }
  }
}
</style>
